module.exports = __webpack_public_path__ + "img/desc.5d8c875a.png";